import React from 'react'
import { Box, Container, Grid2, Typography, Card } from '@mui/material'
import { useAppSettings } from '../../contexts/AppSettingsContext';
import htmlConvert from '../../themeSettings/htmlConvert';
function HomeEvents() {
    const { homeEvents } = useAppSettings() || {};
  return (
    <Box component="div" className="home-events-popup">
    {htmlConvert({ htmlContent: homeEvents || "" })}
  </Box>
  )
}

export default HomeEvents